import _implicitStylesheets from "./pricingSummaryV2.css";
import _implicitScopedStylesheets from "./pricingSummaryV2.scoped.css?scoped=true";
import _wdsLink from "wds/link";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<p class="pricing-headline${0}" type-style="display-7"${2}>${"t1"}</p>`;
const $fragment2 = parseFragment`<p class="pricing-units${0}" type-style="display-8"${2}>${"t1"}</p>`;
const $fragment3 = parseFragment`<p class="pricing-headline-inline${0}" type-style="display-7"${2}>${"t1"}</p>`;
const $fragment4 = parseFragment`<p class="pricing-description${0}" type-style="body-3" data-testid="pricing-summary-description"${2}>${"t1"}</p>`;
const $fragment5 = parseFragment`<p class="pricing-description${0}" type-style="body-3" data-testid="pricing-summary-nonprofit-description"${2}>${"t1"}</p>`;
const $fragment6 = parseFragment`<a${"a0:href"} target="_self" class="pricing-details-anchor${0}" data-testid="pricing-summary-link-anchor"${2}>${"t1"}</a>`;
const stc0 = {
  classMap: {
    "pricing-summary-v2": true
  },
  key: 0
};
const stc1 = {
  classMap: {
    "pricing-header": true
  },
  attrs: {
    "data-testid": "pricing-summary-headline"
  },
  key: 1
};
const stc2 = {
  classMap: {
    "pricing-details-link": true
  },
  key: 12
};
const stc3 = {
  "data-testid": "pricing-summary-link"
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {d: api_dynamic_text, sp: api_static_part, st: api_static_fragment, h: api_element, b: api_bind, c: api_custom_element} = $api;
  const {_m0} = $ctx;
  return [api_element("div", stc0, [api_element("div", stc1, [api_static_fragment($fragment1, 3, [api_static_part(1, null, api_dynamic_text($cmp.summaryHeadline))]), $cmp.summaryHeadlinePaidPlanDetails ? api_static_fragment($fragment2, 5, [api_static_part(1, null, api_dynamic_text($cmp.summaryHeadlinePaidPlanDetails))]) : null, api_static_fragment($fragment3, 7, [api_static_part(1, null, api_dynamic_text($cmp.inlineHeadline))])]), $cmp.summaryDescription ? api_static_fragment($fragment4, 9, [api_static_part(1, null, api_dynamic_text($cmp.summaryDescription))]) : null, $cmp.summaryNonProfitDescription ? api_static_fragment($fragment5, 11, [api_static_part(1, null, api_dynamic_text($cmp.summaryNonProfitDescription))]) : null, $cmp.showPricingDetailsLink ? api_element("div", stc2, [api_custom_element("wds-link", _wdsLink, {
    attrs: stc3,
    props: {
      "target": "_self",
      "href": $cmp.pricingDetailsHref,
      "label": $cmp.pricingDetailsLabel,
      "name": "pricing details"
    },
    key: 13,
    on: {
      "click": _m0 || ($ctx._m0 = api_bind($cmp.handleI18nLinkClick))
    }
  }, [api_static_fragment($fragment6, 15, [api_static_part(0, {
    attrs: {
      "href": $cmp.pricingDetailsHref
    }
  }, null), api_static_part(1, null, api_dynamic_text($cmp.pricingDetailsLabel))])])]) : null])];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-2t7pe3tkjfu";
tmpl.legacyStylesheetToken = "undefined-_pricingSummaryV2";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
